export class FrxBaseBean {
	id: number;
	version: number;
	errorMessage: string;
  createdDate: Date;
  createdBy: string;

	copy(source: FrxBaseBean) {
		this.id = source.id;
		this.version = source.version;
		this.errorMessage = source.errorMessage;

	}
}